import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import {
  Container,
  InnerContainer,
  Title,
  Info,
  MoreWaypoints,
  DownloadAppLink,
  StyledWaypoint,
  WaypointAnchor,
  ButtonEstimate,
}
 from './estimation-form.component.styles'
import { AddressAutocomplete } from '../address-autocomplete/address-autocomplete.component'


const EstimationForm = ({ setPickup, setDropoff, onClick, trackAddressesEstimationsVehicles }) => {
  const [t] = useTranslation()
  const [clickedEstimate, setClickedEstimate] = useState(false)

  const handleClick = () => {
    setClickedEstimate(true)
    onClick()
  }

  return (
    <Container>
      <InnerContainer>
        <Title>{t('text__title__get_a_fee_estimation')}</Title>
        <Info>
          <MoreWaypoints>{t('text__caption__ggv__need_more_waypoints')}</MoreWaypoints>
          <DownloadAppLink
            href={t('link__download_app')}
            target="_blank"
            onClick={() => trackAddressesEstimationsVehicles('click_app_download_link')}
          >
            {t('text__caption__download_our_app')}
          </DownloadAppLink>
        </Info>
        <StyledWaypoint
          anchor={<WaypointAnchor>{t('common__ggv__from')}</WaypointAnchor>}
        >
          <AddressAutocomplete
            placeholder={t('input__placeholder__ggv__select_pickup_point')}
            onChange={setPickup}
            clickedEstimate={clickedEstimate}
            type="pickup"
          />
        </StyledWaypoint>
        <StyledWaypoint
          anchor={<WaypointAnchor>{t('common__ggv__to')}</WaypointAnchor>}
          isDestination
        >
          <AddressAutocomplete
            placeholder={t('input__placeholder__ggv__select_dropoff_point')}
            onChange={setDropoff}
            clickedEstimate={clickedEstimate}
            type="dropoff"
          />
        </StyledWaypoint>
        <ButtonEstimate onClick={handleClick}>{t('button__estimate_fee')}</ButtonEstimate>
      </InnerContainer>
    </Container>
  );
}

EstimationForm.propTypes = {
  setPickup: PropTypes.func.isRequired,
  setDropoff: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  trackAddressesEstimationsVehicles: PropTypes.func.isRequired
}

export { EstimationForm }
